import UIModal from 'UIComponents/dialog/UIModal';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIForm from 'UIComponents/form/UIForm';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = 'userPreferences.passkeys.renameModal';
const RenamePasskeyModal = ({
  renamePasskey,
  renamePasskeyError,
  credentialId,
  hideModal
}) => {
  const [newName, setNewName] = useState('');
  return /*#__PURE__*/_jsx(UIModal, {
    children: /*#__PURE__*/_jsxs(UIForm, {
      onSubmit: event => {
        event.preventDefault();
        renamePasskey(credentialId, newName);
      },
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${langKey}.title`
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: hideModal
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [renamePasskeyError && /*#__PURE__*/_jsx(UIAlert, {
          titleText: "Error",
          type: "danger",
          className: "m-bottom-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${langKey}.error`
          })
        }), /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${langKey}.inputLabel`
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            value: newName,
            onChange: e => setNewName(e.target.value)
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${langKey}.rename`
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: hideModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${langKey}.cancel`
          })
        })]
      })]
    })
  });
};
export default RenamePasskeyModal;